import { useStore } from '@/hooks/useStore';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import { Input } from '@/components/common/Input';
import CheckboxComponent from '@/components/common/CheckBox';
import { Button } from '@/components/common/Button';
import bannerImg from '@/assets/images/pngs/banner-login.png';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES, TYPE_ACCOUNT } from '@/configs/constants';
import { toastify } from '@/utils/toastify';
import { emailRegex } from '@/utils/regex';
import { flowResult } from 'mobx';
import { startAuthentication } from '@simplewebauthn/browser';
import { LoginRequest } from '@/types/http-payload/auth';
import { getStorage, saveLocalStorage } from '@/utils/browsers';

export default observer(function InputEmailPage() {
    // store
    const {
        authStore: { sentOTP, generateAuthentication, login }
    } = useStore();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const { email, isLogin } = location.state || {};
    const email_stored = getStorage('email_passkey');
    const [inputEmail, setInputEmail] = useState<string>((isLogin ? email_stored : email) || '');
    const [checked, setChecked] = useState(false);

    const handleInputEmail = async () => {
        if (!emailRegex.test(inputEmail)) {
            toastify('error', t('text.invalidEmail'));
            return;
        }
        if (isLogin) {
            const resAuth = await flowResult(generateAuthentication({ email: inputEmail }));
            try {
                const dataAuth = await startAuthentication({ optionsJSON: resAuth });
                const body: LoginRequest = {
                    type: TYPE_ACCOUNT.PASSKEY,
                    email: inputEmail,
                    expectedChallenge: resAuth.challenge,
                    body: dataAuth
                };
                const res = await flowResult(login(body));
                if (res) {
                    if (checked) {
                        saveLocalStorage('email_passkey', inputEmail);
                    }
                    navigate(ROUTES.home.href);
                }
            } catch (error) {
                console.log('eeeeeeeee', error);
            }
        } else {
            const body = {
                email: inputEmail
            };
            const res = await flowResult(sentOTP(body));
            if (res) {
                navigate(ROUTES.inputOtp.href, { state: { email: inputEmail, type: TYPE_ACCOUNT.PASSKEY } });
            }
        }
    };
    const goBack = () => {
        navigate(isLogin ? ROUTES.login.href : ROUTES.signUp.href);
    };

    return (

        <div className='w-screen h-screen bg-white'>
            <div className='mx-auto flex w-full h-full flex-col justify-start items-center'>
                <ArrowLeft onClick={goBack} size={24} className='absolute top-[24px] left-[24px] text-white cursor-pointer' />
                <img src={bannerImg} alt='bannerImg' className='w-full h-[30%]' />
                <div className='w-full text-center px-[24px] mt-[-32px] rounded-t-[24px] bg-white pt-[32px] space-y-[24px]'>
                    <p className='text-[27px] font-bold px-[32px]'>{t('text.inputMailPasskey')}</p>

                    <div>
                        <Input
                            placeholder={t('text.inputEmail')}
                            className='h-[48px] w-full'
                            value={inputEmail}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setInputEmail(e.target.value)}
                            type='email'
                        />
                        {isLogin && (
                            <CheckboxComponent
                                className='mt-3 flex justify-start'
                                contentLabel={() => (
                                    <p className='text-left w-full text-[15px]'>
                                        {t('text.remember_me')}
                                    </p>
                                )}
                                onCheckedChange={() => {
                                    if (checked) {
                                        saveLocalStorage('email_passkey', inputEmail);
                                    }
                                    setChecked(!checked);
                                }}
                            />
                        )}

                    </div>
                    <Button
                        variant='main'
                        className='w-full h-[48px] rounded-[10px]'
                        onClick={handleInputEmail}
                        disabled={!emailRegex.test(inputEmail)}
                    >
                        {t('text.continue')}
                    </Button>
                </div>
            </div>
        </div>
    );
});
